module.exports = __webpack_public_path__ + "static/media/icon-pengembangan-pegawai.3ff135de.png";